import type { PartSvgProps } from './types'

export default function PistolGripSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 80,
  height = 160
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 80 160" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Angle cut top — attaches to lower receiver */}
      <path d="M 10 14 L 70 14 L 70 28 L 60 34 L 20 34 L 10 28 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Grip body */}
      <path d="M 20 34 L 60 34 L 66 80 L 62 130 L 52 142 L 28 142 L 18 130 L 14 80 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Finger grooves */}
      <path d="M 14 72 Q 10 80 14 88" fill="none" stroke={accent} strokeWidth="1.2" />
      <path d="M 14 90 Q 10 98 14 106" fill="none" stroke={accent} strokeWidth="1.2" />
      <path d="M 14 108 Q 10 116 14 124" fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Mounting screw hole */}
      <circle cx="40" cy="100" r="5" fill="none" stroke={stroke} strokeWidth="1" />
      {/* Backstrap texture lines */}
      {[50, 60, 70, 80, 90, 100].map((y) => (
        <line key={y} x1={62} y1={y} x2={66} y2={y}
              stroke={stroke} strokeWidth="0.8" />
      ))}
    </svg>
  )
}
